import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StarHalfIcon(props: IconProps) {
    return <Icon {...props} iconKey={"star_half"}/>
}
